<template>
  <Table ref="table" :columns="columns" :data="list">
    <template slot-scope="{ row }" slot="money">
      <Tag type="border" :color="row.money > 0 ? 'success' : 'error'">{{ row.money | money }}</Tag>
    </template>
    
    <template slot-scope="{ row }" slot="current">
      {{ row.current | money }}
    </template>

    <template slot-scope="{ row }" slot="created_at">
      <Time :time="row.created_at * 1000" type="datetime" />
    </template>

  </Table>
</template>
<script>
export default {
  props: {
    list: Array
  },
  data() {
    return {
      columns: [
        {
          title: "ID",
          key: "id",
          width: 100
        },
        {
          title: this.$t("name.user_log.money"),
          slot: 'money',
          align: 'center'
        },
        {
          title: this.$t("name.user_log.current"),
          slot: 'current',
          align: 'center'
        },
        {
          title: this.$t("name.user_log.content"),
          key: 'content',
          minWidth: 450,
        },
        {
          title: this.$t("name.user_log.created_at"),
          slot: 'created_at',
          width: 180
        },
      ],
    };
  },
};
</script>